import clsx from 'clsx';
import { useCallback, useContext, useEffect } from 'react';
import { CheckCircle } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { logAnalyticsEvent } from '@vestico/utils';

import { Button } from '@vestico/shared';
import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import { ConfigContext, MatchButtonGlobalsContext } from '../WidgetEventsManager';
import style from './StaticQuizEndScreen.module.css';

export const StaticQuizEndScreen = () => {
  const { t } = useTranslation();
  const { t: tShared } = useTranslation('shared');
  const { clientId } = useContext(ConfigContext);

  useEffect(() => {
    logAnalyticsEvent({ category: 'event', event: 'static_quiz_end', dimensions: { provider: clientId } });
  }, [clientId]);

  const { setMatchButtonOpen } = useContext(MatchButtonGlobalsContext);
  const onWidgetDone = useCallback(() => {
    setMatchButtonOpen(false);
  }, [setMatchButtonOpen]);

  return (
    <div className={clsx(style.root)}>
      <div>
        <CheckCircle size={36} color="#000000" />
      </div>
      <div className={clsx(style.textContainer)}>
        <h2 className={clsx(globalStyle.textFontHeader, globalStyle.textLarge)}>{t('LOC_WIDGET_STATIC_QUIZ_END_TITLE', { ns: 'translation' })}</h2>
        <h3 className={clsx(globalStyle.textFontHeader, globalStyle.textNormal)}>
          {t('LOC_WIDGET_STATIC_QUIZ_END_SUBTITLE', { ns: 'translation' })}
        </h3>
      </div>
      <div className={clsx(style.buttonContainer)}>
        <Button content={tShared('LOC_DONE_BUTTON', { ns: 'shared' })} onClick={onWidgetDone} size="default" />
      </div>
    </div>
  );
};
